import { Component, JSX } from 'solid-js';

const Ctx = createContext(null as unknown as ConfigProps);

export function Config(props: ParentProps<ConfigProps>) {
  const [, ctx] = splitProps(props, ['children']);
  return <Ctx.Provider value={ctx}>{props.children}</Ctx.Provider>;
}

export function useConfig() {
  return useContext(Ctx);
}

export interface ConfigProps {
  i18n: {
    confirm: string;
    cancel: string;
  };
  icons: {
    close: Component<JSX.SvgSVGAttributes<SVGSVGElement>>;
    error: Component<JSX.SvgSVGAttributes<SVGSVGElement>>;
    success: Component<JSX.SvgSVGAttributes<SVGSVGElement>>;
    warning?: Component<JSX.SvgSVGAttributes<SVGSVGElement>>;
    info?: Component<JSX.SvgSVGAttributes<SVGSVGElement>>;
    arrow: Component<JSX.SvgSVGAttributes<SVGSVGElement>>;
  };
}
